import { FindInPage, SentimentDissatisfied } from "@mui/icons-material";
import { GridApi } from "ag-grid-community";
import React, { FC, useEffect, useState } from "react";

const NoRowsOverlayComponent: FC = (props: any) => {
  const api: GridApi = props.api;
  const [searchActive, setSearchActive] = useState(false);
  useEffect(() => {
    const handleFilterChange = () => {
      // const gridApi: GridApi = e.api;
      let searchActive = false;
      const model = api.getFilterModel();
      if (model) {
        const { externalSearch } = model;
        if (externalSearch) {
          const externalSearchArray = externalSearch?.filter?.split("%|%");
          if (externalSearchArray && !!externalSearchArray[externalSearchArray?.length - 1]) {
            searchActive = true;
          }
        }
      }
      setSearchActive(searchActive);
    };
    handleFilterChange();
    api.addEventListener("filterChanged", handleFilterChange);
    return () => {
      api.removeEventListener("filterChanged", handleFilterChange);
    };
  }, [api]);
  return (
    <div>
      {searchActive ? (
        <>
          <SentimentDissatisfied fontSize="large" />
          <div style={{ fontSize: "1rem" }}>Sorry, no results were found</div>
        </>
      ) : (
        <>
          <FindInPage fontSize="large" />
          <div style={{ fontSize: "1rem" }}>Please start with search to view accounts</div>
        </>
      )}
    </div>
  );
};

export default NoRowsOverlayComponent;
